(function () {
  const drawer = document.querySelector('[data-size-guide-drawer]');
  const overlay = document.querySelector('[data-size-guide-overlay]');
  const closeBtn = document.querySelector('[data-size-guide-close]');

  // If no drawer exists (no size guide found), do nothing.
  if (!drawer || !overlay || !closeBtn) return;

  let lastFocused = null;

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openDrawer() {
    lastFocused = document.activeElement;

    overlay.hidden = false;
    drawer.hidden = false;

    requestAnimationFrame(() => drawer.classList.add('is-open'));

    lockScroll(true);
    drawer.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');

    setTimeout(() => {
      drawer.hidden = true;
      overlay.hidden = true;

      lockScroll(false);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }, 260);
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  // --- Inject "Size Guide" link under the Size & Fit accordion panel ---
  function normalize(text) {
    return (text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function findSizeFitDetails() {
    const details = document.querySelectorAll('details');
    for (const d of details) {
      const summary = d.querySelector('summary');
      if (!summary) continue;

      const label = normalize(summary.textContent);
      // catches "Size & Fit" and "Size and fit"
      if (label.includes('size') && label.includes('fit')) return d;
    }
    return null;
  }

  function injectLink() {
  const details = findSizeFitDetails();
  if (!details) return;

  if (details.querySelector('.size-guide-trigger')) return;

  const content =
    details.querySelector('.accordion__content, .collapsible__content, .rte, [data-accordion-content]') || details;

  const wrap = document.createElement('div');
  wrap.className = 'size-guide-link-wrap';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'size-guide-trigger';
  btn.textContent = 'Size Guide';
  btn.addEventListener('click', openDrawer);

  wrap.appendChild(btn);

  /* Insert right under the paragraph text instead of bottom of accordion */
  const firstParagraph = content.querySelector('p');
  if (firstParagraph) {
    firstParagraph.insertAdjacentElement('afterend', wrap);
  } else {
    content.appendChild(wrap);
  }
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectLink, { once: true });
  } else {
    injectLink();
  }
})();